import { withMotion } from '../hoc/with-motion';
import { UserBoard } from '@/modules/support/components/user-board/board';

const AnimatedPage = withMotion(UserBoard);

export const roles: string[] = ['super-admin', 'supporter'];
export const path = '/support/user';
export const element = <AnimatedPage />